import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import { OfferRequestOptionsDto, OfferRequestOptionsModel } from '../types/offer-request-options'
import {
  GetSellerOfferOptionsResp,
  SellerOfferOptionsDto,
  SellerOfferOptionsModel,
  SellerOfferPriceSuggestionDto,
  SellerOfferPriceSuggestionModel,
} from '../types/seller-offer-options'

const transformOfferPriceSuggestion = ({
  label,
  price,
}: SellerOfferPriceSuggestionDto): SellerOfferPriceSuggestionModel => ({
  label,
  price: transformCurrencyAmountDto(price),
})

export const transformSellerOfferOptionsDto = (
  sellerOfferOptions: SellerOfferOptionsDto,
): SellerOfferOptionsModel => ({
  minPrice: transformCurrencyAmountDto(sellerOfferOptions.min_price),
  maxPrice: transformCurrencyAmountDto(sellerOfferOptions.max_price),
  offerSuggestions:
    sellerOfferOptions.offer_suggestions?.map(transformOfferPriceSuggestion) || null,
  feesReductionThreshold: sellerOfferOptions.fees_reduction_threshold
    ? transformCurrencyAmountDto(sellerOfferOptions.fees_reduction_threshold)
    : null,
})
export const transformSellerOfferOptionsResponse = (
  response: Response<GetSellerOfferOptionsResp>,
) => transformSellerOfferOptionsDto(response.seller_offer_options)

export const transformOfferRequestOptions = (
  response: OfferRequestOptionsDto,
): OfferRequestOptionsModel => ({
  maxDiscount: response.max_discount,
  canMakeMore: response.can_make_more,
  maxOfferCount: response.max_offer_count,
  remainingOfferCount: response.remaining_offer_count,
  minPrice: transformCurrencyAmountDto(response.min_price),
  maxPrice: transformCurrencyAmountDto(response.max_price),
  offerSuggestions: response.offer_suggestions?.map(transformOfferPriceSuggestion) || null,
  feesReductionThreshold: response.fees_reduction_threshold
    ? transformCurrencyAmountDto(response.fees_reduction_threshold)
    : null,
})
